import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zan1_sel",
  "use": "icon-zan1_sel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zan1_sel\"><path d=\"M284.16 391.87968H190.29504c-2.99008 0-29.53728 0.39424-55.92576 14.96576-33.8688 18.74944-52.69504 51.82976-56.08448 98.46272v326.10304c0 0.23552 0.23552 28.7488 14.1824 56.70912 18.27328 37.02272 50.96448 55.69024 97.04448 55.69024l94.65344 0.14336V391.87968zM929.54112 428.1088c-14.80704-21.26848-40.17152-33.71008-75.45856-37.0176v-0.08192h-231.81312l30.8736-215.27552c0-0.15872 3.1488-16.85504-0.62976-35.92192-4.80256-24.73472-18.5088-41.66656-40.56576-50.2528-1.024-0.54784-18.03264-10.78784-39.22432-10.78784-21.10976 0-39.07072 9.92256-53.32992 29.6192L337.5104 387.16928v556.86656l372.18816 0.5632c4.01408 0 99.79904-1.25952 132.49024-112.39936l99.95264-324.13696c0.55808-2.52416 10.48064-46.86848-12.60032-79.95392z\" p-id=\"30691\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/zan1_sel.svg
// module id = Uq0H
// module chunks = 26